var pt = {
  "Add Upsell.com to your ": "Adicionar Upsell.com à sua ",
  "All time": "Todo o tempo",
  "and select": "e selecione",
  "button": "botão",
  "Cart drawer page": "Página da Gaveta do carrinho",
  "Cart page": "Página do Carrinho",
  "Check status": "Verificar estado",
  "Checkout page": "Página de Checkout",
  "Click": "Clique em",
  "Click on": "Clique em",
  "Click the": "Clique no",
  "Custom slot": "Slot personalizado",
  "Custom slots": "Slots personalizados",
  "Custom Slots": "Slots personalizados",
  "contact support.": "contacte o suporte.",
  "from the right sidebar": "da barra lateral direita",
  "Go to your Cart drawer page": "Ir para a sua página da Gaveta do carrinho",
  "Go to your Cart page": "Ir para a sua página do Carrinho",
  "Go to your Checkout page": "Ir para a sua página de Checkout",
  "Go to your Order status page": "Ir para a sua página de Estado da encomenda",
  "Go to your Post purchase page": "Ir para a sua página Pós-compra",
  "Go to your Product page": "Ir para a sua página de Produto",
  "Go to your Thank you page": "Ir para a sua página de Agradecimento",
  "items": "itens",
  "in the left sidebar": "na barra lateral esquerda",
  "Last 12 months": "Últimos 12 meses",
  "Last 30 days": "Últimos 30 dias",
  "Last 365 days": "Últimos 365 dias",
  "Last 7 days": "Últimos 7 dias",
  "Last 90 days": "Últimos 90 dias",
  "Last month": "Mês passado",
  "Last year": "Ano passado",
  "Make sure": "Certifique-se de que",
  "Need assistance? Contact our support team for help.": "Precisa de ajuda? Contacte a nossa equipa de suporte.",
  "Order status page": "Página de Estado da encomenda",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "A nossa aplicação está a passar por um pouco de magia para melhorar a sua experiência.",
  "Post purchase page": "Página Pós-compra",
  "Product page": "Página de Produto",
  "Save": "Guardar",
  "Scroll to the bottom and select": "Role para baixo e selecione",
  "Select": "Selecionar",
  "Success. Please continue.": "Sucesso. Por favor, continue.",
  "Thank you page": "Página de Agradecimento",
  "The Upsell.com team.": "A equipa Upsell.com.",
  "The Upsell.com widget is not placed on ": "O widget Upsell.com não está colocado em ",
  ". Please follow the steps above or ": ". Por favor, siga os passos acima ou ",
  "Today": "Hoje",
  "toggle is on": "o botão está ligado",
  "Total": "Total",
  "under": "em",
  "We apologize for any inconvenience caused,": "Pedimos desculpa por qualquer inconveniente causado,",
  "We apologize for any inconvenience caused.": "Pedimos desculpa por qualquer inconveniente causado.",
  "We'll be done in a few minutes!": "Terminaremos em alguns minutos!",
  "We're improving our services!": "Estamos a melhorar os nossos serviços!",
  "Widget already added": "Widget já adicionado",
  "Yesterday": "Ontem",
  "You placed the widget on the ": "Colocou o widget em ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", mas não o guardou no editor do Shopify. Por favor, volte a ",
  " and save the changes.": " e guarde as alterações."
};

export { pt as default };
//# sourceMappingURL=pt.json.js.map
